<template>
  <div class="orderGoods">
    <div class="total">共{{ cartInfo.length }}件商品</div>
    <div class="goodWrapper">
      <div
        class="item acea-row row-between-wrapper"
        v-for="cart in cartInfo"
        :key="cart.id"
      >
        <div class="pictrue rel">
          <img
            v-if="cart.is_gift"
            class="abs gift-logo"
            src="//aijiutang.oss-cn-beijing.aliyuncs.com/work_time/assets/images/gift_icon.png"
          />
          <img
            :src="cart.productInfo.img"
            class="image"
            v-if="cart.productInfo.img"
          />
          <img v-else src="@assets/images/noGood.png" class="image" />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1 ub ubv-c">
              {{ cart.productInfo.title }}
              <span v-if="cart.is_gift" class="gift">{{
                cart.gift_msg ||
                  (cart.is_gift == 1
                    ? "赠品"
                    : cart.is_gift == 2
                    ? "买一送一"
                    : "买二送一")
              }}</span>
            </div>
            <div class="num">x {{ cart.cart_num }}</div>
          </div>
          <div class="attr line1" v-if="cart.productInfo.attrInfo">
            {{ cart.productInfo.attrInfo.suk }}
          </div>
          <div class="money font-color-red">￥{{ cart.truePrice }}</div>
          <div
            class="evaluate"
            v-if="evaluate === 3"
            @click="$router.push({ path: '/goods_evaluate/' + cart.unique })"
          >
            评价
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderGoods",
  props: {
    evaluate: Number,
    cartInfo: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {}
};
</script>
<style scoped>
.gift {
  background: red;
  color: #ffffff;
  padding: 1px 5px;
  font-size: 0.2rem;
  margin-left: 0.1rem;
}
.gift-logo {
  left: 0;
  top: 0;
  width: 0.5rem;
  height: 0.5rem;
}
</style>
